export default "__VITE_ASSET__BnzPlZPj__"